import { useMemo, useState } from 'react';
import { termsOfServiceStepIndex } from "../../ClientOnboarding.utils";
export const useTermsOfServiceStatement = _ref => {
  var _termsOfServiceStepIn;
  let {
    relationship,
    currentStep,
    shouldSignStatement,
    isPreview
  } = _ref;
  const termsOfServices = useMemo(() => {
    var _relationship$legalTe, _relationship$legalTe2;
    return (_relationship$legalTe = (_relationship$legalTe2 = relationship.legalTermsDocuments) === null || _relationship$legalTe2 === void 0 ? void 0 : _relationship$legalTe2.slice(0, 4)) !== null && _relationship$legalTe !== void 0 ? _relationship$legalTe : [];
  }, [relationship.legalTermsDocuments]);
  const [termsOfServiceStatements, setTermsOfServiceStatements] = useState(() => termsOfServices.map(termsOfService => shouldSignStatement || isPreview ? !(termsOfService.termsOfService.type === 'explicitApproval' && termsOfService.termsOfService.explicitApproval.statement) : true));
  const currentTermsIndex = (_termsOfServiceStepIn = termsOfServiceStepIndex[currentStep]) !== null && _termsOfServiceStepIn !== void 0 ? _termsOfServiceStepIn : -1;
  const isTermsOfServiceStep = currentTermsIndex >= 0;
  const isStatementAccepted = isTermsOfServiceStep ? termsOfServiceStatements[currentTermsIndex] : true;
  const currentStatement = useMemo(() => {
    if (!isTermsOfServiceStep || !shouldSignStatement) return null;
    const termsOfService = termsOfServices[currentTermsIndex];
    if (!termsOfService) return null;
    return termsOfService.termsOfService.type === 'explicitApproval' ? termsOfService.termsOfService.explicitApproval.statement : null;
  }, [isTermsOfServiceStep, currentTermsIndex, termsOfServices, shouldSignStatement]);
  const handleStatementChange = isAccepted => {
    if (currentTermsIndex >= 0) {
      setTermsOfServiceStatements(prev => {
        const next = [...prev];
        next[currentTermsIndex] = isAccepted;
        return next;
      });
    }
  };
  const isNextDisabled = isTermsOfServiceStep && !isStatementAccepted;
  return {
    currentStatement,
    isStatementAccepted,
    isTermsOfServiceStep,
    isNextDisabled,
    handleStatementChange
  };
};